
import { useLang } from '@/i18n';
import styles from './index.module.scss';
import EcoTitle from 'eco-design/base/eco-title';
import EcoSpace from 'eco-design/base/eco-space';
import EcoImg from 'eco-design/base/eco-img';

export default function Comp() {
    const { t } = useLang('dp3.page_v2.OnePicture');

    const items = [
      {
        title: t('title1'),
        desc: t('desc1'),
        pc: 'https://websiteoss.ecoflow.com/upload/image/1745457396254/2.jpg',
        pad: 'https://websiteoss.ecoflow.com/upload/image/1745457396254/2.jpg',
        h5: "https://websiteoss.ecoflow.com/upload/image/1745458261978/2-h5.jpg"
      },
      {
        title: t('title2'),
        desc: t('desc2'),
        pc: 'https://websiteoss.ecoflow.com/upload/image/1745457394369/1.jpg',
        pad: 'https://websiteoss.ecoflow.com/upload/image/1745457394369/1.jpg',
        h5: "https://websiteoss.ecoflow.com/upload/image/1745458259929/1-h5.jpg"
      },
      {
        title: t('title3'),
        pc: 'https://websiteoss.ecoflow.com/upload/image/1745457394927/5.jpg',
        pad: 'https://websiteoss.ecoflow.com/upload/image/1745457394927/5.jpg',
        h5: "https://websiteoss.ecoflow.com/upload/image/1745458260655/5-h5.jpg"
      },
      {
        title: t('title4'),
        pc: 'https://websiteoss.ecoflow.com/upload/image/1745457396433/3.jpg',
        pad: 'https://websiteoss.ecoflow.com/upload/image/1745457396433/3.jpg',
        h5: "https://websiteoss.ecoflow.com/upload/image/1745458261797/3-h5.jpg"
      },
      {
        title: t('title5'),
        pc: 'https://websiteoss.ecoflow.com/upload/image/1745457396065/6.jpg',
        pad: 'https://websiteoss.ecoflow.com/upload/image/1745457396065/6.jpg',
        h5: "https://websiteoss.ecoflow.com/upload/image/1745458260293/6-h5.jpg"
      },
      {
        title: t('title6'),
        pc: 'https://websiteoss.ecoflow.com/upload/image/1745457395706/4.jpg',
        pad: 'https://websiteoss.ecoflow.com/upload/image/1745457395706/4.jpg',
        h5: "https://websiteoss.ecoflow.com/upload/image/1745458260472/4-h5.jpg"
      },
      {
        title: t('title7'),
        desc: t('desc7'),
        pc: 'https://websiteoss.ecoflow.com/upload/image/1745457395886/7.jpg',
        pad: 'https://websiteoss.ecoflow.com/upload/image/1745457395886/7.jpg',
        h5: "https://websiteoss.ecoflow.com/upload/image/1745458261045/7-h5.jpg"
      },
      {
        title: t('title8'),
        pc: 'https://websiteoss.ecoflow.com/upload/image/1745457395503/8.jpg',
        pad: 'https://websiteoss.ecoflow.com/upload/image/1745457395503/8.jpg',
        h5: "https://websiteoss.ecoflow.com/upload/image/1745458260841/8-h5.jpg"
      },
      {
        title: t('title9'),
        desc: t('desc9'),
        pc: 'https://websiteoss.ecoflow.com/upload/image/1745457395125/9.jpg',
        pad: 'https://websiteoss.ecoflow.com/upload/image/1745457395125/9.jpg',
        h5: "https://websiteoss.ecoflow.com/upload/image/1745458261243/9-h5.jpg"
      },
      {
        title: t('title10'),
        desc: t('desc10'),
        list: [
          { icon: 'https://websiteoss.ecoflow.com/upload/image/1745476129935/1.png', text: t('list10_1') },
          { icon: 'https://websiteoss.ecoflow.com/upload/image/1745476130071/2.png', text: t('list10_2') },
          { icon: 'https://websiteoss.ecoflow.com/upload/image/1745476130278/3.png', text: t('list10_3') },
          { icon: 'https://websiteoss.ecoflow.com/upload/image/1745476130474/4.png', text: t('list10_4') },
          { icon: 'https://websiteoss.ecoflow.com/upload/image/1745476131179/5.png', text: t('list10_5') },
          { icon: 'https://websiteoss.ecoflow.com/upload/image/1745476130866/6.png', text: t('list10_6') },
          { icon: 'https://websiteoss.ecoflow.com/upload/image/1745476130668/7.png', text: t('list10_7') },
        ],
        pc: 'https://websiteoss.ecoflow.com/upload/image/1745457395319/10.jpg',
        pad: 'https://websiteoss.ecoflow.com/upload/image/1745457395319/10.jpg',
        h5: "https://websiteoss.ecoflow.com/upload/image/1745458261432/10-h5.jpg"
      },
    ]

    return (
        <div className={styles.comp} id="OnePicture">
          <EcoSpace />
          <EcoTitle title={t('title')} />
          <div className='grid'>
            {items.map((i,idx) => (
              <div key={idx} className={`grid-item grid-item-${idx + 1}`}>
                <EcoImg pc={i.pc} pad={i.pad} h5={i.h5} />
                <div className='info'>
                  {i.title && <div className='item-title'>{i.title}</div>}
                  {i.desc && <div className='item-desc'>{i.desc}</div>}
                </div>
                {i.list && (
                  <div className='list'>
                    {i.list.map((j, idx2) => (
                      <div className='list-item' key={`${idx}-${idx2}`}>
                        <img className='list-icon' src={j.icon} alt="" />
                        <div className='list-text'>{j.text}</div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
          <EcoSpace />
        </div>
    );
}